import MyCard from "@common-utils/MyCard"
import React, { createContext, useState } from "react"
import * as Yup from "yup"
import { IExportHierarchyContextModel } from "./models"
import ExportHierarchyPrime from "./ExportHierarchyPrime"
import ExportSelectType from "./ExportSelectType"
import ExportAssurance from "./ExportAssurance"
import ExportTurnoverParConsultant from "./ExportTurnoverParConsultant"

const Exports = () => {
     const [selectedType, setSelectedType] = useState<"ASSURANCE" | "HIERARCHY" | "NB_JOURS_TRAVAILLES_PAR_MOIS_PAR_CONSULTANT" | "CA_FORFAIT_AT" | null>(null)

     const schema = Yup.object().shape({
          type: Yup.string().label("`Type`").required(),
     })

     return (
          <ExportHierarchyContext.Provider
               value={{
                    selectedType,
                    setSelectedType,
               }}
          >
               <div className={"d-flex justify-content-center"}>
                    <div className={"w-100 w-md-80 w-lg-75 w-xl-60"}>
                         <MyCard>
                              <MyCard.Header>
                                   <span className={"fas fa-file-export fs-3 text-dark me-2"} /> Exports
                              </MyCard.Header>
                              <MyCard.Body classNames={"m-2"}>
                                   {selectedType !== null ? (
                                        <>
                                             {selectedType === "HIERARCHY" && (
                                                  <>
                                                       <h4 className="mb-4">Export hiérarchie prime</h4>
                                                       <div className="separator separator-dashed mb-6"></div>
                                                       <ExportHierarchyPrime />
                                                  </>
                                             )}

                                             {selectedType === "ASSURANCE" && (
                                                  <>
                                                       <h4 className="mb-4">Export assurance</h4>
                                                       <div className="separator separator-dashed mb-6"></div>
                                                       <ExportAssurance />
                                                  </>
                                             )}

                                             {selectedType === "CA_FORFAIT_AT" && (
                                                  <>
                                                       <h4 className="mb-4">Export turnover par consultant</h4>
                                                       <div className="separator separator-dashed mb-6"></div>
                                                       <ExportTurnoverParConsultant />
                                                  </>
                                             )}
                                        </>
                                   ) : (
                                        <ExportSelectType />
                                   )}
                              </MyCard.Body>
                         </MyCard>
                    </div>
               </div>
          </ExportHierarchyContext.Provider>
     )
}

const ExportHierarchyContext = createContext<IExportHierarchyContextModel>({} as IExportHierarchyContextModel)

export { Exports, ExportHierarchyContext }
